/**
 * THIS IS GENERATED CODE!
 * PLEASE DO NOT MODIFY - ALL YOUR WORK WOULD BE LOST!
 */
export const typescriptDeclarationFixConstant = 1;
export enum UiRepeatableAnimation {
	BOUNCE, FLASH, PULSE, RUBBER_BAND, SHAKE_X, SHAKE_Y, HEAD_SHAKE, SWING, TADA, WOBBLE, JELLO, HEART_BEAT, FLIP, BLINK, BLINK_SUBTLE
}